import React from "react";
import OrderListCommonLayer from "./OrderListCommonLayer";

const UnfulfilledOrdersLayer = () => {
    return (
        <OrderListCommonLayer
            pageTitle="Unfulfilled Orders"
            categoryStatus="Unfulfilled"
            categoryPayStatus="Paid"
        />
    );
};

export default UnfulfilledOrdersLayer;
